import { Suspense } from 'react';
import { RSimProductActionSelectButton } from './RSimProductActionSelectButton.tsx';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { ActionsToolbar } from 'products/common/actions/ActionsToolbar.tsx';

export const RSimProductActionToolbar = () => {
  const { t } = useTranslation();
  return (
    <ActionsToolbar>
      <Suspense
        fallback={
          <Button color="secondary" endIcon={<ArrowDropDownIcon />} disabled>
            {t('products.rSim.actions.action')}
          </Button>
        }
      >
        <RSimProductActionSelectButton />
      </Suspense>
    </ActionsToolbar>
  );
};
